import React from 'react'
import { Box, VStack, Heading, Button, Text, Link } from '@chakra-ui/react'
import { BsArrowRight } from 'react-icons/bs'
import { useTranslation } from 'react-i18next'
import { getValidUrl } from '@/utils'
import { AnimatePresence, motion } from 'framer-motion'

type DefinitionProps = {
  slug: string
  name: string
  shortDescription?: string
  selectedWord?: string
  isMobile?: boolean
}

export const Definition = ({
  slug,
  name,
  shortDescription,
  selectedWord,
  isMobile = true,
}: DefinitionProps) => {
  const { t, i18n } = useTranslation()
  return (
    <Box marginLeft={{ base: 0, lg: 12 }}>
      <VStack alignItems="flex-start">
        <Heading
          fontSize={[24, null, null, 22]}
          fontWeight={[600, null, null, 700]}
          lineHeight={['140%', null, null, '135%']}
          color={'gray.900'}
          dangerouslySetInnerHTML={{ __html: name }}
        />
        <Text
          color={'gray.900'}
          fontSize={[14, null, null, 16]}
          fontWeight={400}
          lineHeight={'150%'}
          mt={8}
        >
          {shortDescription}
        </Text>
        <AnimatePresence>
          {(isMobile || selectedWord === name) && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ opacity: 0, height: 0 }}
            >
              <a
                href={getValidUrl('/glossary', i18n.language) + `/${slug}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  mt={8}
                  variant={'link'}
                  color={'blue.200'}
                  rightIcon={<BsArrowRight fontSize={'20px'} />}
                >
                  <Text textStyle={'textCta'}>
                    {t('homepage.fullDefinition')}
                  </Text>
                </Button>
              </a>
            </motion.div>
          )}
        </AnimatePresence>
      </VStack>
    </Box>
  )
}
